import React, { useState, useEffect } from 'react';
import './Navbar.css';
import ContactModal from './ContactModal';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [showContactModal, setShowContactModal] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <>
      <nav className={`navbar ${isScrolled ? 'navbar-scrolled' : ''}`}>
        <div className="container">
          <div className="navbar-brand">
            <h1 className="logo">Idle Robotics</h1>
            <span className="logo-tagline">Industrial Automation Solutions</span>
          </div>
          <div className={`navbar-menu ${isMobileMenuOpen ? 'active' : ''}`}>
            <ul className="nav-links">
              <li><a href="#home" onClick={() => setIsMobileMenuOpen(false)}>Home</a></li>
              <li><a href="#solutions" onClick={() => setIsMobileMenuOpen(false)}>Products</a></li>
              <li><a href="#industries" onClick={() => setIsMobileMenuOpen(false)}>Industries</a></li>
              <li><a href="#footer" onClick={() => setIsMobileMenuOpen(false)}>About</a></li>
            </ul>
          </div>
          <div className="navbar-actions">
            <button className="btn btn-primary" onClick={() => setShowContactModal(true)}>
              Request Demo
            </button>
            <button 
              className={`mobile-menu-toggle ${isMobileMenuOpen ? 'active' : ''}`}
              onClick={toggleMobileMenu}
              aria-label="Toggle mobile menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </div>
      </nav>
      {showContactModal && <ContactModal onClose={() => setShowContactModal(false)} />}
    </>
  );
};

export default Navbar;